import React, { useCallback, useEffect, useState } from 'react';
import HorizontalStack from '../horizontal-stack';
import IconButton from '../icon-button';

const ActionRadioGroup = ({
  options,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
  onChange = null,
  selectedId,
  gap = 'auto',
  wrap = false,
  preventActiveItemChange = false,
}) => {
  const [active, setActive] = useState(selectedId);

  useEffect(() => {
    setActive(selectedId);
  }, [selectedId]);

  const onClick = useCallback(
    (option) => {
      if (active === option.id) return;

      if (!preventActiveItemChange) {
        setActive(option.id);
      }

      if (onChange) onChange(option);
      if (option.onClick) option.onClick(option);
    },
    [onChange, active, preventActiveItemChange]
  );

  if (options.length < 2) {
    return null;
  }

  const align = gap === 'auto' ? 'space-between' : 'left';
  const gapProp = gap === 'auto' ? 'spacing-4-xs' : gap;

  return (
    <div className="ws-ui-action-radio-group">
      <HorizontalStack align={align} gap={gapProp} wrap={wrap}>
        {options.map((option) => {
          const isActive = option.id === active;
          return (
            <IconButton
              key={option.id}
              glyph={option.glyph}
              size="large"
              label={option.label}
              selected={isActive}
              onClick={() => onClick(option)}
              appearance="light-accent"
            />
          );
        })}
      </HorizontalStack>
    </div>
  );
};

export default ActionRadioGroup;
